import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Avatar,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack,
  TextField,
  Divider,
} from "@mui/material";
import CustomButton from "../Components/CustomButton";
import logoImg from "../media/suspect.jpeg";
import Footer from "../Components/Footer";
import { UserAuth } from "../context/AuthContext";
import Iconify from "../Components/Iconify";
import { useNavigate } from "react-router-dom";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db, functions } from "../firebase.config";
import EditName from "./profile/profile_componnent_edit/editName";
import EditGender from "./profile/profile_componnent_edit/editGenre";
import EditPhone from "./profile/profile_componnent_edit/editNumber";
import EditAddress from "./profile/profile_componnent_edit/editAddress";
import EditAgeRange from "./profile/profile_componnent_edit/editBirth";
import EditAvatarModal from "./profile/profile_componnent_edit/editAvatarModal";

// Mapping lisible pour la tranche d’âge
const AGE_LABELS = {
  "moins-18": "Moins de 18 ans",
  "18-24": "Jeunes adultes (18 à 24 ans)",
  "25-34": "Adultes (25 à 34 ans)",
  "35-44": "Adultes (35 à 44 ans)",
  "45-54": "Adultes (45 à 54 ans)",
  "55-64": "Seniors actifs (55 à 64 ans)",
  "65-plus": "65 ans et plus",
};

const options = ["Deconnexion"];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Profile() {
  const { user, logOut } = UserAuth();
  const navigate = useNavigate();

  const [nom, setNom] = React.useState("");
  const [prenom, setPrenom] = React.useState("");
  const [mail, setMail] = React.useState("");
  const [urlPhoto, setUrlPhoto] = React.useState("");

  const [dateNaissance, setDateNaissance] = React.useState("");
  const [ageRange, setAgeRange] = React.useState("");
  const [genre, setGenre] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [billingCommune, setBillingCommune] = React.useState("");
  const [billingVille, setBillingVille] = React.useState("");
  const [billingPays, setBillingPays] = React.useState("");
  const [openAvatarModal, setOpenAvatarModal] = React.useState(false);



  const [loading, setLoading] = React.useState(false);
  const [editingSection, setEditingSection] = React.useState(null); // 'name', 'birthdate', 'gender', 'email', 'phone', 'address'

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        if (user) {
          const u1 = await getDoc(doc(db, "users", `${user.uid}`));
          if (u1.exists()) {
            const data = u1.data();
            setNom(data.nom || "");
            setPrenom(data.prenom || "");
            setMail(data.email || user.email || "");
            setUrlPhoto(data.photoUrl || "");

            setAgeRange(data.ageRange || "");
            setGenre(data.genre || "");
            setPhone(data.phone || "");
            setBillingCommune(data.billingCommune || "");
            setBillingVille(data.billingVille || "");
            setBillingPays(data.billingPays || "");

          }
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, [user]);

  const handleUpdateUser = async (newData) => {
    if (!user) return;
    await updateDoc(doc(db, "users", user.uid), newData);
  };


  return (
    <>
      <Container sx={{ paddingX: { xs: 2, sm: 5 }, paddingY: 10 }}>
        <Stack justifyContent='center' alignItems={'center'}>
          <Stack paddingTop={5} spacing={3} just sx={{
            width: { xs: "100%", sm: "70%" },
          }}>
            <Typography
              sx={{
                fontSize: "30px",
                fontWeight: "500",
              }}

            >
              Informations personnelles
            </Typography>


            <Box sx={{ border: '2px solid #f2f2f2', borderRadius: '10px', padding: 2 }}>
              <Stack spacing={2}>
                <Typography variant="h6">Informations generales</Typography>
                <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ cursor: "pointer" }}
  onClick={() => setOpenAvatarModal(true)}>
                  <Stack width={'100%'} direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 5 }} >
                    <Box width={{ xs: '50%', sm: '20%' }}>
                      <Typography variant="body2">
                        Photo de profil
                      </Typography>
                    </Box>

                    <Typography>
                      Ajouter un photo pour personnaliser votre compte
                    </Typography>
                  </Stack>
                  {
                    !urlPhoto ? <Avatar sx={{ bgcolor: '#5E17EB', width: 50, height: 50 }}>{prenom.slice(0, 1).toUpperCase()}{nom.slice(0, 1).toUpperCase()}</Avatar>
                      : <Avatar src={urlPhoto} sx={{ width: 55, height: 55 }}></Avatar>
                  }
                </Stack>
                <Divider />
                {/* Nom & Prénom */}
                {editingSection === "name" ? (
                  <EditName
                    initialNom={nom}
                    initialPrenom={prenom}
                    onCancel={() => setEditingSection(null)}
                    onSubmit={async ({ nom: newNom, prenom: newPrenom }) => {
                      await handleUpdateUser({ nom: newNom, prenom: newPrenom });
                      setNom(newNom);
                      setPrenom(newPrenom);
                      setEditingSection(null);
                    }}
                  />
                ) : (
                  <Stack
                    direction={"row"}
                    spacing={2}
                    alignItems={"center"}
                    onClick={() => setEditingSection("name")}
                    sx={{ cursor: "pointer" }}
                  >
                    <Stack
                      width={"100%"}
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 5 }}
                    >
                      <Box width={{ xs: "50%", sm: "20%" }}>
                        <Typography variant="body2">Nom</Typography>
                      </Box>

                      <Typography>
                        {nom} {prenom}
                      </Typography>
                    </Stack>
                    <Iconify icon="fluent:chevron-right-24-filled" />
                  </Stack>
                )}

                <Divider />
                {/* Tranche d’âge */}
                {editingSection === "ageRange" ? (
                  <EditAgeRange
                    initialAgeRange={ageRange}
                    onCancel={() => setEditingSection(null)}
                    onSubmit={async ({ ageRange: newAgeRange }) => {
                      await handleUpdateUser({ ageRange: newAgeRange });
                      setAgeRange(newAgeRange);
                      setEditingSection(null);
                    }}
                  />
                ) : (
                  <Stack
                    direction={"row"}
                    spacing={2}
                    alignItems={"center"}
                    onClick={() => setEditingSection("ageRange")}
                    sx={{ cursor: "pointer" }}
                  >
                    <Stack
                      width={"100%"}
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 5 }}
                    >
                      <Box width={{ xs: "50%", sm: "20%" }}>
                        <Typography variant="body2">Tranche d’âge</Typography>
                      </Box>

                      <Typography>
                        {ageRange
                          ? AGE_LABELS[ageRange] || ageRange
                          : "Ajouter une tranche d’âge"}
                      </Typography>
                    </Stack>
                    <Iconify icon="fluent:chevron-right-24-filled" />
                  </Stack>
                )}

                <Divider />
                {/* Genre */}
                {editingSection === "gender" ? (
                  <EditGender
                    initialGender={genre}
                    onCancel={() => setEditingSection(null)}
                    onSubmit={async ({ genre: g }) => {
                      await handleUpdateUser({ genre: g });
                      setGenre(g);
                      setEditingSection(null);
                    }}
                  />
                ) : (
                  <Stack
                    direction={"row"}
                    spacing={2}
                    alignItems={"center"}
                    onClick={() => setEditingSection("gender")}
                    sx={{ cursor: "pointer" }}
                  >
                    <Stack
                      width={"100%"}
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 5 }}
                    >
                      <Box width={{ xs: "50%", sm: "20%" }}>
                        <Typography variant="body2">Genre</Typography>
                      </Box>

                      <Typography>{genre || "Sélectionner un genre"}</Typography>
                    </Stack>
                    <Iconify icon="fluent:chevron-right-24-filled" />
                  </Stack>
                )}
              </Stack>
            </Box>
            <Box sx={{ border: '2px solid #f2f2f2', borderRadius: '10px', padding: 2 }}>
              <Stack spacing={2}>
                <Typography variant="h6">Coordonnées</Typography>
                <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ cursor: 'not-allowed' }}>
                  <Stack width={'100%'} direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 5 }} >
                    <Box width={{ xs: '50%', sm: '20%' }}>
                      <Typography variant="body2">
                        Adresse email
                      </Typography>
                    </Box>

                    <Typography>{mail}</Typography>
                  </Stack>
                </Stack>
                <Divider />
                {/* Téléphone */}
                {editingSection === "phone" ? (
                  <EditPhone
                    initialPhone={phone}
                    onCancel={() => setEditingSection(null)}
                    onSubmit={async ({ phone: p }) => {
                      await handleUpdateUser({ phone: p });
                      setPhone(p);
                      setEditingSection(null);
                    }}
                  />
                ) : (
                  <Stack
                    direction={"row"}
                    spacing={2}
                    alignItems={"center"}
                    onClick={() => setEditingSection("phone")}
                    sx={{ cursor: "pointer" }}
                  >
                    <Stack
                      width={"100%"}
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 5 }}
                    >
                      <Box width={{ xs: "50%", sm: "20%" }}>
                        <Typography variant="body2">Téléphone (whatsapp)</Typography>
                      </Box>

                      <Typography>{phone || "Ajouter un numéro"}</Typography>
                    </Stack>
                    <Iconify icon="fluent:chevron-right-24-filled" />
                  </Stack>
                )}
              </Stack>
            </Box>


            <Box sx={{ border: "2px solid #f2f2f2", borderRadius: "10px", padding: 2 }}>
              <Stack spacing={2}>
                <Typography variant="h6">Adresses</Typography>

                {/* Adresse de facturation */}
                {editingSection === "address" ? (
                  <EditAddress
                    initialCommune={billingCommune}
                    initialVille={billingVille}
                    initialPays={billingPays}
                    onCancel={() => setEditingSection(null)}
                    onSubmit={async (updated) => {
                      await handleUpdateUser(updated);
                      setBillingCommune(updated.billingCommune);
                      setBillingVille(updated.billingVille);
                      setBillingPays(updated.billingPays);
                      setEditingSection(null);
                    }}
                  />
                ) : (
                  <Stack
                    direction={"row"}
                    spacing={2}
                    alignItems={"center"}
                    onClick={() => setEditingSection("address")}
                    sx={{ cursor: "pointer" }}
                  >
                    <Stack
                      width={"100%"}
                      direction={{ xs: "column", sm: "row" }}
                      spacing={{ xs: 1, sm: 5 }}
                    >
                      <Box width={{ xs: "50%", sm: "20%" }}>
                        <Typography variant="body2">Facturation</Typography>
                      </Box>

                      <Typography>
                        {billingCommune || billingVille || billingPays
                          ? `${billingCommune || ""}, ${billingVille || ""}, ${billingPays || ""}`
                          : "Ajouter votre adresse de facturation"}
                      </Typography>
                    </Stack>
                    <Iconify icon="fluent:chevron-right-24-filled" />
                  </Stack>
                )}
              </Stack>
            </Box>
          </Stack>
        </Stack>
      </Container>
      <EditAvatarModal
  open={openAvatarModal}
  onClose={() => setOpenAvatarModal(false)}
  currentPhotoUrl={urlPhoto}
  userId={user.uid}
  onPhotoUpdated={async (newUrl) => {
    // Mise à jour Firestore + state local
    await handleUpdateUser({ photoUrl: newUrl });
    setUrlPhoto(newUrl);
  }}
/>
      <Footer />
    </>
  );
}
